import React from 'react';
import styled from 'styled-components';

const StyledMargins = styled.div`
  padding: 0 24px;

  @media screen and (max-width: 320px) and (max-width: 599px) {
    padding: 0 24px;
  }

  @media screen and (min-width: 600px) and (max-width: 899px) {
    padding: 0 32px;
  }

  @media screen and (min-width: 900px) and (max-width: 1199px) {
    padding: 0 40px;
  }

  @media screen and (min-width: 1200px) {
    padding: 0 48px;
  }
`;

type Props = {
  children: React.ReactNode;
  styles?: React.CSSProperties;
};

const ContentMargins = ({ children, styles }: Props): React.ReactNode => {
  return <StyledMargins style={styles}>{children}</StyledMargins>;
};

export default ContentMargins;
